import React from 'react';
import AuthorizedRoute from './AuthorizedRoute';
import * as Roles from '../../constants/roles';

export const AdminRoute = ({ allowedRoles, ...rest }) => (
  <AuthorizedRoute
    {...rest}
    allowedRoles={[Roles.ADMIN]}
  />
);

export const ManagerRoute = ({ allowedRoles, ...rest }) => (
  <AuthorizedRoute
    {...rest}
    allowedRoles={[Roles.ADMIN, Roles.SCHEDULER]}
  />
);



// WEBPACK FOOTER //
// ./src/components/routes/index.js